/* ============================================================================
   Dashboard — visão geral do sistema.
   ============================================================================ */
import { useState, useEffect } from 'react';
import api from '../../services/api';
import AdminLayout from '../components/AdminLayout';
import PageHeader from '../components/PageHeader';
import { Loading, EmptyState, PlanBadge } from '../components/ui';
import { IconBook, IconGift, IconTag, IconUsers } from '../components/icons';
import './Dashboard.css';

const STAT_CARDS = [
  { key: 'totalCourses', label: 'Total de cursos', icon: IconBook, tone: 'coffee' },
  { key: 'freeCourses', label: 'Cursos gratuitos', icon: IconGift, tone: 'green' },
  { key: 'paidCourses', label: 'Cursos pagos', icon: IconTag, tone: 'amber' },
  { key: 'totalEnrollments', label: 'Total de inscrições', icon: IconUsers, tone: 'blue' },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/admin/stats', true);
        if (res.success) setStats(res.data);
      } catch (err) {
        console.error('Erro ao carregar estatísticas:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const enrollments = stats?.coursesWithEnrollments || [];

  return (
    <AdminLayout>
      <PageHeader title="Dashboard" subtitle="Visão geral da plataforma de cursos" />

      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dash-stats">
            {STAT_CARDS.map(({ key, label, icon: Icon, tone }) => (
              <div key={key} className={`dash-stat dash-stat-${tone}`}>
                <div className="dash-stat-icon"><Icon size={22} /></div>
                <div className="dash-stat-body">
                  <span className="dash-stat-value">{stats?.[key] ?? 0}</span>
                  <span className="dash-stat-label">{label}</span>
                </div>
              </div>
            ))}
          </div>

          <section className="dash-section">
            <div className="dash-section-head">
              <h2>Inscrições por curso</h2>
              <span className="mg-toolbar-count">{enrollments.length} {enrollments.length === 1 ? 'curso' : 'cursos'}</span>
            </div>

            {enrollments.length === 0 ? (
              <EmptyState icon={<IconUsers size={26} />} title="Nenhuma inscrição ainda">
                Assim que houver alunos inscritos, os números aparecem aqui.
              </EmptyState>
            ) : (
              <div className="dash-enroll-list">
                {enrollments.map((course) => (
                  <div key={course.id} className="dash-enroll">
                    <div className="dash-enroll-info">
                      <span className="dash-enroll-title">{course.title}</span>
                      {course.category && <span className="dash-enroll-cat">{course.category}</span>}
                    </div>
                    <div className="dash-enroll-right">
                      <PlanBadge
                        free={course.isFree}
                        label={course.isFree ? 'Gratuito' : `R$ ${course.price}`}
                        color="#d17d34"
                      />
                      <div className="dash-enroll-count">
                        <span className="dash-enroll-num">{course.enrollments}</span>
                        <span className="dash-enroll-num-lbl">inscritos</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        </>
      )}
    </AdminLayout>
  );
}
